import { Route } from 'react-router-dom';
import { LedgerMain } from '../ui/ledger/LedgerMain';

export const ledgerRoutes = [
  <Route path="/ledger" element={<LedgerMain />} key="ledger" />,
];

